import ReactSwitch from 'react-switch';
import baseColors from 'styles/config/colors/baseColors';

export type CustomisedToggleProps = {
  toggleOn: boolean;
  handleToggle?: any;
  requestLoading?: boolean;
  readonly?: boolean;
  width?: number;
  height?: number;
  disabled?: boolean;
};

// react-switch parses color props as hex values internally (for shadow and
// hover colour derivation). CSS `var()` strings don't survive that, so the
// toggle renders invisibly. Resolve tokens to concrete hex values here —
// same approach the pre-migration styled-components Toggle used.
const TOGGLE_ON = baseColors.black;
const TOGGLE_OFF = baseColors.newGrey['50'];
const DISABLED_SUBTLE = baseColors.newGrey['20'];
const DISABLED_STRONG = baseColors.newGrey['40'];

const Toggle = ({
  toggleOn,
  handleToggle,
  requestLoading = false,
  readonly = false,
  width = 40,
  height = 20,
  disabled,
  ...props
}: CustomisedToggleProps) => {
  const isDisabled = readonly || requestLoading || disabled;

  return (
    <ReactSwitch
      checked={toggleOn}
      checkedIcon={false}
      className="!opacity-100 focus:outline-1 focus:outline-background-primary"
      disabled={isDisabled}
      height={height}
      offColor={isDisabled ? DISABLED_SUBTLE : TOGGLE_OFF}
      uncheckedIcon={false}
      width={width}
      onChange={handleToggle}
      onColor={isDisabled ? DISABLED_STRONG : TOGGLE_ON}
      {...props}
    />
  );
};

export default Toggle;
